import React from 'react';
import { IOnlinePayment } from '@components/Sura/Stepper/OnlinePayment/types';
import { Grid } from '@material-ui/core';
import useStyles from '@components/Sura/Stepper/styles';

import PaymentMethodCard from '@components/Sura/PaymentMethodCard';
import VISA_MASTERCAD from '@assets/images/VisaoMasterCard.png';
import AMEX from '@assets/images/Amex.png';
import CLABE from '@assets/images/CuentaClabe.png';
import { PaymentOption } from '@store/sura';
import { observer } from 'mobx-react';
import useStore from '@hooks/useStore';
import { validationPaymentMethod } from '@utils/suraValidation';

const OnlinePayment: React.FC<IOnlinePayment> = () => {
  const { sura, ui, links } = useStore();
  const css = useStyles({ isMobile: ui.isMobileScreen });
  const { paymentMethods } = links.paymentConfig;
  const isSubscription = links.paymentLink.isSubscription;

  return (
    <>
      {sura.step === 1 && (
        <>
          {!isSubscription ? (
            <label className={css.labelPayment}>
              Selecciona tu <span className={css.labelExtraBold}>Medio de Pago</span>
            </label>
          ) : (
            <label className={css.labelPayment}>
              Selecciona el tipo de tarjeta para domiciliar tu pago
            </label>
          )}
          <Grid className={css.divCards} container spacing={ui.isMobileScreen ? 1 : 3}>
            <Grid xs={ui.isMobileScreen ? 12 : 4}>
              <PaymentMethodCard
                imageSrc={VISA_MASTERCAD}
                paymentMethod={'Visa o MasterCard'}
                description={
                  !isSubscription
                    ? 'Realiza tu pago con tu tarjeta de crédito o debito'
                    : 'Suscribe tu pago con tarjetas de crédito Visa o MasterCard'
                }
                disabled={validationPaymentMethod(paymentMethods.card)}
                paymentMethodSelected={''}
                paymentOption={PaymentOption.visa_mastercard}
              />
            </Grid>
            <Grid xs={ui.isMobileScreen ? 12 : 4}>
              <PaymentMethodCard
                imageSrc={AMEX}
                paymentMethod={'American Express'}
                description={
                  !isSubscription
                    ? 'Realiza tu pago con tarjeta de crédito AMEX'
                    : 'Suscribe tu pago con tarjeta de crédito AMEX'
                }
                disabled={validationPaymentMethod(paymentMethods.card)}
                paymentMethodSelected={''}
                paymentOption={PaymentOption.american}
              />
            </Grid>
            {!isSubscription && (
              <Grid xs={ui.isMobileScreen ? 12 : 4}>
                <PaymentMethodCard
                  imageSrc={CLABE}
                  paymentMethod={'Cuenta clabe'}
                  description={'Ingresa tu cuenta Clabe y nosotros procesamos el pago.'}
                  disabled={validationPaymentMethod(paymentMethods.directDebit)}
                  paymentMethodSelected={''}
                  paymentOption={PaymentOption.clabe}
                />
              </Grid>
            )}
          </Grid>
        </>
      )}
    </>
  );
};

export default observer(OnlinePayment);
